interface StatusBadgeProps {
  status: string;
  className?: string;
}

const STATUS_COLORS: Record<string, string> = {
  active: 'bg-emerald-500/10 text-emerald-400',
  approved: 'bg-emerald-500/10 text-emerald-400',
  completed: 'bg-emerald-500/10 text-emerald-400',
  signed: 'bg-emerald-500/10 text-emerald-400',
  hired: 'bg-emerald-500/10 text-emerald-400',
  open: 'bg-blue-500/10 text-blue-400',
  pending: 'bg-amber-500/10 text-amber-400',
  in_progress: 'bg-amber-500/10 text-amber-400',
  self_review: 'bg-amber-500/10 text-amber-400',
  manager_review: 'bg-amber-500/10 text-amber-400',
  interview: 'bg-blue-500/10 text-blue-400',
  screening: 'bg-blue-500/10 text-blue-400',
  assessment: 'bg-purple-500/10 text-purple-400',
  offer: 'bg-cyan-500/10 text-cyan-400',
  draft: 'bg-muted/10 text-muted-foreground',
  new: 'bg-blue-500/10 text-blue-400',
  denied: 'bg-red-500/10 text-red-400',
  rejected: 'bg-red-500/10 text-red-400',
  terminated: 'bg-red-500/10 text-red-400',
  cancelled: 'bg-muted/10 text-muted-foreground',
  on_leave: 'bg-yellow-500/10 text-yellow-400',
  overdue: 'bg-red-500/10 text-red-400',
  expired: 'bg-red-500/10 text-red-400',
  not_started: 'bg-muted/10 text-muted-foreground',
  sent: 'bg-blue-500/10 text-blue-400',
  viewed: 'bg-cyan-500/10 text-cyan-400',
  calibration: 'bg-purple-500/10 text-purple-400',
  acknowledged: 'bg-emerald-500/10 text-emerald-400',
  withdrawn: 'bg-muted/10 text-muted-foreground',
  paused: 'bg-yellow-500/10 text-yellow-400',
  closed: 'bg-muted/10 text-muted-foreground',
  filled: 'bg-emerald-500/10 text-emerald-400',
  exceptional: 'bg-emerald-500/10 text-emerald-400',
  exceeds_expectations: 'bg-blue-500/10 text-blue-400',
  meets_expectations: 'bg-amber-500/10 text-amber-400',
  needs_improvement: 'bg-orange-500/10 text-orange-400',
  unsatisfactory: 'bg-red-500/10 text-red-400',
};

export function StatusBadge({ status, className = '' }: StatusBadgeProps) {
  const colors = STATUS_COLORS[status] ?? 'bg-muted/10 text-muted-foreground';
  const label = (status ?? '').replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());

  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${colors} ${className}`}>
      {label}
    </span>
  );
}
